import { createDecorator } from '../../instantiation/common/instantiation.js';
const IRequestService = ( createDecorator('requestService'));
export { IRequestService };
